import * as React from "react";

const UserIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
  >
    <g clipPath="url(#a)">
      <path
        fill="#024"
        stroke="#024"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.972"
        d="M6 5.074A1.852 1.852 0 1 0 6 1.37a1.852 1.852 0 0 0 0 3.704"
      ></path>
      <path fill="#024" d="M10.167 10.63a4.167 4.167 0 1 0-8.334 0"></path>
      <path
        stroke="#024"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.972"
        d="M10.167 10.63a4.167 4.167 0 1 0-8.334 0z"
      ></path>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.444.444h11.111v11.111H.445z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default UserIcon;
